module.exports = __webpack_public_path__ + "static/media/volaby-original-dark.effb30ee.svg";